<template>
  <div>
    <div class="fixed-top topbar-menu bg-white shadow-sm">
      <a href="https://parceiros.lecard.delivery/" class="d-block bg-primary py-1 text-center">
        <h6 class="h6 m-0 font-weight-bold small">LeCard GO</h6>
      </a>
    </div>
    <div style="padding: 25vh 0 80px">
      <div class="container text-center">
        <div class="mb-4 text-muted">
          <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 24 24" width="48" height="48" fill="currentColor"><path d="M12 24a12 12 0 1 1 12-12 12.013 12.013 0 0 1-12 12m0-22a10 10 0 1 0 10 10A10.01 10.01 0 0 0 12 2m5.746 15.667a1 1 0 0 0-.08-1.413A9.45 9.45 0 0 0 12 14a9.45 9.45 0 0 0-5.666 2.254 1 1 0 0 0 1.33 1.494A7.5 7.5 0 0 1 12 16a7.5 7.5 0 0 1 4.336 1.748 1 1 0 0 0 1.41-.081M6 10c0 1 .895 1 2 1s2 0 2-1a2 2 0 0 0-4 0m8 0c0 1 .895 1 2 1s2 0 2-1a2 2 0 0 0-4 0"/></svg>
        </div>
        <h1 class="text-dark font-weight-bold h5 mb-2">Empresa não encontrada!</h1>
        <p class="text-dark mb-5">Desculpe mas não encontramos essa empresa em nossa base de dados.</p>
      </div>
      <div class="fixed-bottom pb-4">
        <ads-le-card hide-ads="true"/>
      </div>
    </div>
  </div>
</template>

<script>
  import AdsLeCard from "../../../components/AdsLeCard";
  import Loading from '../../../components/Loading'

  export default {
    name: 'Pedidos',
    components: {AdsLeCard, Loading},
    data() {
      return {
        load: false
      }
    }
  }
</script>
<style scoped>
</style>
